<div class="bd_login">
    <div class="container-fluid pl-0 pr-0">
        <div class="row no-gutters align-items-center">
            <div class="col-lg-6">
                <div class="bd_loginimg">
                    <img src="assets/img/img2.png" class="login_bg">
                    <div class="bd_loginlogo">
                        <a routerLink="/"><img src="assets/img/logo.png"></a>
                        <div class="bd_logintext">
                            <!-- <h2>E-trade Platform For <br>Private Sales And Procurement</h2> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="bd_loginbox">
                    <h3>Sign in as {{ roleDetails.role }}</h3>
                    <p>Enter your details below.</p>

                    <form [formGroup]="loginForm">
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <input type="text" appArrowNavigation formControlName="email" placeholder="Email" [class.is-invalid]="( !Global.isInputValid(loginForm, 'email') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(loginForm, 'email', 'required')">
                                    <div>This field is required</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(loginForm, 'email', 'email')">
                                    <div>Please enter valid email</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12">
                                <input type="password" appArrowNavigation formControlName="password" placeholder="Password" [class.is-invalid]="( !Global.isInputValid(loginForm, 'password') )" class="form-control">

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'required')">
                                    <div>This field is required</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'minlength')">
                                    <div>The password must be minimum 6 characters</div>
                                </div>

                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(loginForm, 'password', 'maxlength')">
                                    <div>The password must be maximum 20 characters</div>
                                </div>
                            </div>

                            <div class="form-group col-sm-12 text-right">
                                <a class="bd_forgot" href="javascript:;" (click)="initForgotPassword()">Forgot Password?</a>
                            </div>



                            <div class="col-12">
                                <button type="submit" class="btn" (click)="submit($event)">
                                    <span class="indicator-label">Sign In</span>

                                    <span class="indicator-progress">Please wait...
                                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>

                            <div class="col-12 bd_signtext mt-4">
                                You don't have an account? <a routerLink="/register">Sign Up</a>
                            </div>

                            <div class="col-12 text-center mt-2">
                                <!-- <hr> -->
                                <a routerLink="/">&#8592; back to Home</a>

                            </div>

                            </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #forgotPasswordModal="bs-modal" class="modal bd_popmodal fade" tabindex="-1" role="dialog" aria-labelledby="projectTaskUserStatusModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button class="close" (click)="cancelForgotPassword()"><i class="fa fa-times" aria-hidden="true"></i></button>

                <div class="bd_loginbox bd_forgotbox">
                    <h3>Forgot Your Password?</h3>
                    <p>Put Your Registered Email Id here..We Will Send You Back a OTP to reset your password now</p>
                    <fieldset>
                        <form [formGroup]="forgotPasswordForm">
                            <div class="form-group">
                                <input class="form-control input-lg" placeholder="E-mail Address" formControlName="email" [class.is-invalid]="( !Global.isInputValid(forgotPasswordForm, 'email') )">
                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(forgotPasswordForm, 'email', 'required')">
                                    <div>This field is required</div>
                                </div>
                                <!-- <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(forgotPasswordForm, 'email', 'email')">
                                    <div>Please enter valid email</div>
                                </div>   -->
                                <div class="invalid-feedback" *ngIf="!Global.isInputRuleValid(forgotPasswordForm, 'email', 'emailValidation')">
                                    <div>Please enter a valid email</div>
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary" (click)="submitForgotPassword($event)">
                                <span class="indicator-label">Send OTP</span>
                                <span class="indicator-progress">Please wait...
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </form>
                    </fieldset>
                </div>
                </div>
            </div>
        </div>
    </div>


